<template>
  <el-date-picker
    v-model="dates"
    :picker-options="pickerOptions"
    :clearable="false"
    :editable="false"
    class="date-width"
    type="monthrange"
    start-placeholder="开始月份"
    end-placeholder="结束月份"
    range-separator="至"
    value-format="yyyy-MM"
    :default-value="new Date()"
    placeholder="选择月份">
  </el-date-picker>
</template>

<script>
export default {
  data() {
    return {
      dates: this.dateValue,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [{
          text: '本月',
          onClick(picker) {
            picker.$emit('pick', [new Date(), new Date()]);
          }
        }, {
          text: '今年至今',
          onClick(picker) {
            const end = new Date();
            const start = new Date(new Date().getFullYear(), 0);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近六个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setMonth(start.getMonth() - 6);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    }
  },
  watch: {
    dates: function (newVal, oldVal) {
      this.$emit("update:dateValue", newVal);
    },
  },
  name: "datetime-picker",
  model: {
    prop: 'dateValue',
    event: 'change'
  },
  props: {
    dateValue: {
      type: Array,
      default: []
    }
  },
  methods: {
    reset(val){
      this.dates=val;
    }
  }
}
</script>

<style scoped>
.date-width{
  width: 390px;
}
</style>



// WEBPACK FOOTER //
// src/components/date-picker/month-picker.vue